import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Icon, { type IconName } from '../../Components/Icon';

interface MenuItem {
  to: string;
  label: string;
  icon: IconName;
  exact?: boolean;
  type: 'nav' | 'link';
}

function Sidebar() {
  const offcanvasRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeMenu = () => {
    const offcanvas = offcanvasRef.current;
    if (offcanvas && offcanvas.classList.contains('show')) {
      const dismissBtn = offcanvas.querySelector<HTMLButtonElement>('[data-bs-dismiss]');
      dismissBtn?.click();
    }
  };

  const logOut = () => {
    dispatch({ type: 'USER_LOGOUT' });
    navigate('/panel/login');
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `list-group-item d-flex justify-content-between align-items-center w-100 ${isActive ? 'active' : ''}`;

  const menuItems: MenuItem[] = [
    { to: '/panel', label: 'داشبورد', icon: 'speedometer', exact: true, type: 'nav' },
    { to: '/panel/exams', label: 'آزمون‌ها', icon: 'beaker', exact: true, type: 'nav' },
    { to: '/panel/user-exams', label: 'نتایج آزمون‌ها', icon: 'graph-up', exact: true, type: 'nav' },
    { to: '/panel/exam-history-charts', label: 'نمودار پیشرفت آزمون‌ها', icon: 'collection', exact: true, type: 'nav' },
    { to: '/panel/bookmark', label: 'کلمات بوکمارک شده', icon: 'type', exact: true, type: 'nav' },
    { to: '/panel/leitner', label: 'جعبه لایتنر', icon: 'journals', exact: true, type: 'nav' },
    { to: '/panel/referral', label: 'معرفی و اعتبار', icon: 'gift', exact: true, type: 'nav' },
    { to: '/panel/package', label: 'خرید اشتراک', icon: 'gear', type: 'link' },
    { to: '/contact', label: 'پشتیبانی', icon: 'life-preserver', type: 'link' },
  ];

  return (
    <aside className="col-lg-3 col-xxl-3 mb-3 mb-lg-0">
      <div
        className="offcanvas-lg offcanvas-end"
        tabIndex={-1}
        id="sidebarMenu"
        aria-labelledby="sidebarMenuLabel"
        ref={offcanvasRef}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title" id="sidebarMenuLabel">پنل GREhub</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            data-bs-target="#sidebarMenu"
            aria-label="بستن"
          />
        </div>
        <div className="offcanvas-body ps-3">
          <div className="panel-sidebar sticky-top-md d-flex flex-column gap-3">
            <div className="list-group">
              {menuItems.map((item) => {
                if (item.type === 'nav') {
                  return (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      end={item.exact}
                      className={linkClass}
                      onClick={closeMenu}
                    >
                      <span className="d-flex align-items-center gap-2">
                        <Icon name={item.icon} size={18} strokeWidth={1.4} />
                        {item.label}
                      </span>
                      <Icon name="chevron-left" size={14} strokeWidth={1.8} />
                    </NavLink>
                  );
                }

                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="list-group-item d-flex justify-content-between align-items-center w-100"
                    onClick={closeMenu}
                  >
                    <span className="d-flex align-items-center gap-2">
                      <Icon name={item.icon} size={18} strokeWidth={1.4} />
                      {item.label}
                    </span>
                    <Icon name="chevron-left" size={14} strokeWidth={1.8} />
                  </Link>
                );
              })}
            </div>
            <div className="panel-premium p-3 mt-3">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="d-flex align-items-center gap-2">
                  <Icon name="stars" size={20} strokeWidth={1.4} />
                  <strong>پریمیوم شوید</strong>
                </div>
                <Link to="/panel/package" className="btn btn-light btn-sm fw-bold" onClick={closeMenu}>
                  <Icon name="box-arrow-up-right" size={16} strokeWidth={1.4} className="me-1" />
                  ارتقا
                </Link>
              </div>
              <div className="small mt-2" style={{ opacity: 0.9 }}>
                دسترسی نامحدود به همه آزمون‌ها و تحلیل‌ها
              </div>
            </div>
          </div>

          <div className="d-lg-none mt-3">
            <button type="button" className="btn btn-outline-danger w-100" onClick={() => { closeMenu(); logOut(); }}>
              <Icon name="box-arrow-right" size={18} strokeWidth={1.4} className="ms-1" />
              خروج
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
